import { VodItemViewProps } from '@/types/vod/VodItem'
import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useVodItemViewLogic } from '../../hooks/useVodItemViewLogic'
import HoverItemDetails from '@/features/VOD/components/itemDetails/HoverItemDetails'
import { ProgressBar } from '@/features'
import { VodItemLabel } from '@/features/VOD/components/VodItemLabel'
import { useVODStore } from '@/shared/store'
import placeholderPoster from '@/shared/assets/images/placeholderPoster.webp'
import { vodType } from '@/shared/constants'

const VodItemView = ({
    vodItemHeight,
    item,
    handleGoToCategoryButtonClick,
    scrollPosition,
    hideCaptions,
    hideProgress,
    rowHeightPercentage,
    cardRadiusDp,
    isHomeContentItem,
}: VodItemViewProps) => {
    const {
        watchingProgress,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        itemAspectRatio,
        handleMouseEnter,
        handleMouseLeave,
        handleItemClick,
        details,
        imageUrl,
        title,
        label,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        imageDimensions,
    } = useVodItemViewLogic(item, handleGoToCategoryButtonClick)

    const theme = useTheme()
    const { setIsLinkedFromHome } = useVODStore()

    const isVod = item.assetType === vodType
    const displayProgressBar = !hideProgress && isVod
    const itemHeight = rowHeightPercentage
        ? vodItemHeight * (rowHeightPercentage / 100)
        : vodItemHeight

    const itemBoxStyle = {
        scrollSnapAlign: 'end',
        position: 'relative',
        '&:hover': {
            cursor: 'pointer',
        },
    }

    const titleStyle = {
        textAlign: 'center',
        typography: 'label2',
        marginTop: '31px',
        color: 'white',
    }

    const vodContentStyle = {
        // height: `${itemHeight}px`,
        // width: `${
        //     itemAspectRatio ? itemHeight * itemAspectRatio : itemHeight
        // }px`,
        height: `${itemHeight}px`,
        // width: `${
        //     itemAspectRatio ? itemHeight * itemAspectRatio : itemHeight
        // }px`,
        width: 'auto',
        borderRadius: cardRadiusDp
            ? `${cardRadiusDp}px`
            : theme.shape.borderRadius,
        overflow: 'hidden',
    }

    const progressBarWrapper = {
        position: 'absolute',
        bottom: '20px',
        left: '15%',
        width: '70%',
    }
    const labelStyle = {
        position: 'absolute',
        top: '-20px',
        right: '0px',
    }
    const imageStyle = {
        position: 'relative',
        height: '100%',
        width: '100%',
    }
    const hoverImageStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        transition: 'opacity 0.3s ease-in-out, backdropFilter 0.4s ease-in-out',
        opacity: 0,
        '&:hover': {
            backdropFilter: 'blur(10px)',
            opacity: 1,
        },
        overflow: 'hidden',
    }

    const handleClick = () => {
        handleItemClick()
        isHomeContentItem && setIsLinkedFromHome(true)
    }
    return (
        <>
            <Box
                sx={itemBoxStyle}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={handleClick}>
                <Box sx={vodContentStyle}>
                    <Box position="relative" sx={imageStyle}>
                        <Box sx={hoverImageStyle}>
                            {details && <HoverItemDetails details={details} />}
                        </Box>
                        <LazyLoadImage
                            alt={item.title || 'movie poster'}
                            src={imageUrl}
                            height={itemHeight}
                            // width={itemWidth}
                            style={{
                                objectFit: 'contain',
                            }}
                            scrollPosition={scrollPosition}
                            placeholderSrc={placeholderPoster}
                            onError={(event) => {
                                const target = event.target as HTMLImageElement
                                target.onerror = null
                                target.src = placeholderPoster
                            }}
                        />
                        {displayProgressBar && (
                            <Box sx={progressBarWrapper}>
                                <ProgressBar
                                    value={watchingProgress}
                                    min={1}
                                    max={100}
                                    width={100}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>
                {!hideCaptions && (
                    <Typography sx={titleStyle}>{title}</Typography>
                )}
            </Box>

            {label && (
                <Box sx={labelStyle}>
                    <VodItemLabel label={label} />
                </Box>
            )}
        </>
    )
}

export default VodItemView
